// extracted by mini-css-extract-plugin
export var billingAddress = "_y1-g";
export var contactInfo = "_y1-d";
export var customerInfoContainer = "_y1-c";
export var customerInfoContainerMobile = "_y1-h";
export var customerInfoRow = "_y1-a";
export var customerInfoSection = "_y1-b";
export var fullWidthDividerMobile = "_y1-i";
export var imageContainer = "_y1-1";
export var paymentMethod = "_y1-e";
export var priceText = "_y1-6";
export var priceTextMobile = "_y1-7";
export var product = "_y1-0";
export var productImage = "_y1-2";
export var productInfo = "_y1-4";
export var productMobile = "_y1-9";
export var productTitle = "_y1-8";
export var quantityBadge = "_y1-3";
export var quantityText = "_y1-5";
export var shippingAddress = "_y1-f";